import { Component } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { MessageService } from 'primeng/api';
import { Machine } from 'src/app/shared/models/machine';
import { Proprietaire } from 'src/app/shared/models/proprietaire';
import { AuthService } from 'src/app/shared/service/auth/auth.service';
import { FecthDataService } from 'src/app/shared/service/fetchservice/fetchservice';
import { ParameterService } from 'src/app/shared/service/params/param';
import { LocalStorageService } from 'src/app/shared/service/storage/localstorage.service';

@Component({
  selector: 'app-add-parametrage-machine',
  templateUrl: './add-parametrage-machine.component.html',
  styleUrl: './add-parametrage-machine.component.scss'
})
export class AddParametrageMachineComponent {
  item: Machine = new Machine();
  proprietaire: Proprietaire = new Proprietaire();
  departementItems: any;
  typeMachinItems: any;
  accessoireItems: any;
  etatItems: any;
  photoPreview: string | ArrayBuffer | null = null;
  visible: boolean = false;
  isvisibleProprietaire: boolean = false;
  reference: any
  position: string = 'center';
  constructor(
    private modalService: NgbModal,
    private messageService: MessageService,
    private authService: AuthService,
    private fecthDataService: FecthDataService,
    private ngxService: NgxUiLoaderService,
    private localStorage: LocalStorageService,
    private paramService: ParameterService,
    private ngxservice: NgxUiLoaderService

  ) { }



  ngOnInit() {
    this.reference = this.localStorage.getUsers().data;

    this.getTypemachine();
  }



  close() {

    this.modalService.dismissAll();
  }

  closeProprietaireModal() {
    if (!this.proprietaire.canSave()) {
      this.isvisibleProprietaire = true;
      this.messageService.add({ severity: 'info', summary: "AfriCereal", detail: this.proprietaire.getErrorMessage() });
      return;

    }
    this.isvisibleProprietaire = false;

  }

  addMachine() {
    if (!this.item.canSave()) {
      this.messageService.add({ severity: 'info', summary: "AfriCereal", detail: this.item.getErrorMessage() });
      return;
    }
    if (!this.proprietaire.canSave()) {
      this.position = "left"

      this.isvisibleProprietaire = true;
      return;
    }


    else {
      this.ngxservice.start();
      this.isvisibleProprietaire = false;

      // Récupérer les accessoires sélectionnés
      const accessoiresSelectionnes = this.accessoireItems
        .filter((item: any) => item.accessoire_machine_id) // Vérifie les cases cochées
        .map((item: any) => item.id); // Récupère les identifiants

      // Créer l'objet FormData
      let formData: FormData = new FormData();
      formData.append('nom', this.item.nom);
      formData.append('numero_serie', this.item.numero_serie);
      formData.append('type_machine_id', this.item.type_machine_id);
      formData.append('type_maintenance', this.item.type_maintenance);
      formData.append('etats_machines_id', this.item.etats_machines_id);
      formData.append('condition_location', this.item.condition_location);
      formData.append('montant', this.item.montant);
      formData.append('image', this.item.image);
      formData.append('user_id', this.reference.reference);
      formData.append('localisation', this.item.localisation);

      // Ajouter les accessoires sous forme de tableau ou de chaîne JSON
      formData.append('accessoires_machines', JSON.stringify(accessoiresSelectionnes));


      formData.append('proprietaire[nom]', this.proprietaire.nom);
      formData.append('proprietaire[prenom]', this.proprietaire.prenom);
      formData.append('proprietaire[telephone]', this.proprietaire.telephone);
      formData.append('proprietaire[email]', this.proprietaire.email);
      formData.append('proprietaire[adresse]', this.proprietaire.adresse);


      // Envoyer la requête
      this.paramService.addMachine(formData).subscribe(
        (response: any) => {
          this.ngxservice.stop();
          this.modalService.dismissAll();
          this.messageService.add({
            severity: 'success',
            summary: "AfriCereal",
            detail: response.message,
          });
          this.fecthDataService.notifySeriviceCreated();
        },
        (error: any) => {
          this.ngxservice.stop();
          this.messageService.add({
            severity: 'error',
            summary: "AfriCereal",
            detail: error,
          });
        }
      );
    }
  }

  showDialog(position: string) {
    this.position = position;
    this.visible = true;
  }
  onFileSelected(event: any) {
    const file: File = event.target.files[0];
    if (file) {
      this.item.image = file;

      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.photoPreview = e.target.result;
      };
      reader.readAsDataURL(file);
    }
  }

  getTypemachine() {
    this.paramService.getTypeMachine().subscribe(
      (response: any) => {
        this.typeMachinItems = response.data;
        console.log("typeMachinItems", this.typeMachinItems);
        this.getAccessoire();
      },

      (error: any) => {
        console.log("erreur est survenu", error);

      }
    )
  }

  getAccessoire() {
    this.paramService.getAccessoire().subscribe(
      (response: any) => {
        this.accessoireItems = response.data;
        console.log("accessoireItems", this.accessoireItems);
        this.getEtat();
      },

      (error: any) => {
        console.log("erreur est survenu", error);

      }
    )
  }
  getEtat() {
    this.paramService.getEtat().subscribe(
      (response: any) => {
        this.etatItems = response.data;
        console.log("etatItems", this.etatItems);

      },

      (error: any) => {
        console.log("erreur est survenu", error);

      }
    )
  }
  onOkClick(): void {
    console.log(this.accessoireItems);

    this.visible = false;
  }

}
